module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_preocupacion_mobile.c58e9707.jpg";